import { Component, OnInit, Inject } from "@angular/core";
import {
  MatTableDataSource,
  MatDialog,
  MAT_DIALOG_DATA,
} from "@angular/material";
import { Router } from "@angular/router";
import { AppService } from "src/_services/app.service";
import { AuthenticationService } from "src/_services/authentication.service";
import { CommonModalComponent } from "src/app/pages/common-dialog-management/common-dialog.component";
import { BetConfigReqParams } from "src/_models";
import {
  roleTypeOperator,
  roleTypeSap,
  disableConfigData,
  SapRoles,
} from "src/_constants/roleType";
import { FormControl } from "@angular/forms";

@Component({
  selector: "app-provider-management",
  templateUrl: "./provider-management.component.html",
  styleUrls: ["./provider-management.component.scss"],
})
export class ProviderManagementComponent implements OnInit {
  providersDisplayedColumns: string[] = [
    "ProviderId",
    "PartnerId",
    "ProviderName",
    "Currency",
    "Rate",
    "Status",
    "Action",
  ];

  providers = new MatTableDataSource();
  providersStatus = new MatTableDataSource();
  providerId: string;
  count: number = 0;
  searchUserName: string = "";
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  configData: any;
  showOperatorData: boolean = true;
  showSAPData: boolean = true;
  sapRoles = SapRoles;
  OperatorId : string = "";
  operatorData = [];
  dropdownSettings: any = {};
  opId = new FormControl([]);
  constructor(
    private appService: AppService,
    private router: Router,
    private authService: AuthenticationService,
    public dialog: MatDialog
  ) {}

  goTo(link) {
    if (this.userRole.role !== this.sapRoles.GroupAdmin) {
      this.OperatorId = this.userRole.operatorId
    }
    let linkRoute = `/administration/providers/${this.OperatorId }/` + link.ProviderId;
    this.appService.setProvider(link)
    this.router.navigate([linkRoute]);
  }

  goToLimits() {
    this.router.navigate(["/administration/limits"], {
      queryParams: { OperatorId: this.OperatorId },
    });
  }

  ngOnInit() {    
    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    if (this.sapRoles.RolexAdmin === this.userRole.role) {
      this.providersDisplayedColumns = [ "ProviderId","ProviderName"]
    }
    if (disableConfigData.includes(this.userRole.role)) {
      this.providersDisplayedColumns = this.providersDisplayedColumns.filter(
        (item) => item !== "Action"
      );
    }
    this.showOperatorData = roleTypeOperator.includes(this.userRole.role) || this.userRole.role === SapRoles.GroupAdmin;
    this.showSAPData = roleTypeSap.includes(this.userRole.role);
    this.getOperatorData();
  }

  getOurProviders(operator) {
    try {
      this.appService.getOurProviders1(operator).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.providers.data = res.providers;
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  getOperatorData() {
    if (this.userRole.role === "GroupAdmin") {
      this.operatorData = this.userRole.operators;
      this.onSelectedOperatorId(this.operatorData[0]);
    } else {
        this.getOurProviders(this.OperatorId);
    }
  }

  onSelectedOperatorId = (oid) => {
    this.OperatorId = oid;
    this.opId.setValue([oid]);
    this.getOurProviders(this.OperatorId);
  };

  handleClick(data) {
    if (this.userRole.role === "SAPAdmin" || this.userRole.role === "SAPUser" || this.userRole.role === "RiskAdmin") {
      try {
        this.appService
          .getOperatorsData({
            ProviderId: data.ProviderId,
            SportId: "",
            CompetitionId: "",
            EventId: "",
          })
          .subscribe((res) => {
            if (res.status === "RS_OK") {
              this.providersStatus.data = res.providers;
              this.dialog.open(CommonModalComponent, {
                backdropClass: "backdropBackground",
                hasBackdrop: true,
                data: {
                  providersStatus: this.providersStatus,
                  title: data.ProviderId,
                  proStatus: data.Status,
                  ProviderId: data.ProviderId,
                  sportId: "",
                  CompetitionId: "",
                  EventId: "",
                  For: "SAP",
                  code: 0,
                  level: "provider",
                },
              });
            } else {
              if (res.errorDescription === "Invalid Token!") {
                sessionStorage.clear();
                this.router.navigateByUrl("/login");
              }
            }
          });
      } catch (err) {}
    }
  }

  handleChange(e, provider) {
    let providerId = provider.ProviderId
      ? provider.ProviderId
      : provider.providerId;
    if (e.checked) {
      this.appService
        .unBlockProvider(providerId, provider.partnerId, this.OperatorId)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.appService.openSuccessBar(res.errorDescription);
            this.getOurProviders(this.OperatorId);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    } else {
      this.appService
        .blockProvider(providerId, provider.partnerId, this.OperatorId)
        .subscribe((res) => {
          if (res.status === "RS_OK") {
            this.getOurProviders(this.OperatorId);
            this.appService.openSuccessBar(res.errorDescription);
          } else {
            this.appService.openErrorBar(res.errorDescription);
          }
        });
    }
  }

  chnageCongifData(data) {
    const postBody: BetConfigReqParams = {
      ConfigCall: "partner",
      ProviderId: data.ProviderId ? data.ProviderId : data.providerId,
      PartnerId: data.partnerId,
      SportId: data.SportId,
      CompetitionId: "",
      EventId: "",
      OperatorId: this.OperatorId,
    };

    this.dialog.open(CommonModalComponent, {
      backdropClass: "backdropBackground",
      hasBackdrop: true,
      data: {
        ConfigData: null, //
        ConfigCall: null, //
        For: "OP",
        page: "partner",
        OperatorId: this.OperatorId,
        ProviderId: data.ProviderId ? data.ProviderId : data.providerId,
        PartnerId: data.partnerId ? data.partnerId : "NA",
        SportId: "",
        CompetitionId: "",
        EventId: "",
        apiReqBody: postBody,
        level: "provider",
      },
    });
  }
}

@Component({
  selector: "dialog-data-example-dialog",
  templateUrl: "./provider-info-modal.html",
  styleUrls: ["./provider-management.component.scss"],
})
export class ProviderStatusModalComponent {
  providerStatusDisplayedColumns: string[] = [
    "OperatorId",
    "OperatorName",
    "OperatorStatus",
  ];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private appService: AppService
  ) {}

  handleChangeStatus(e, data) {
    // if (e.checked) {
    //   this.appService
    //     .unBlockModalProvider(data.ProviderId, data.OperatorId)
    //     .subscribe((res) => console.log(res));
    // } else {
    //   this.appService
    //     .blockModalProvider(data.ProviderId, data.OperatorId)
    //     .subscribe((res) => console.log(res));
    // }
  }
}
